import React, { useEffect, useState } from "react";
import { Card, Button, Divider, Space, Tooltip } from "antd";
import { HomeOutlined } from '@ant-design/icons';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { compute } from "../utils/cwnsrange";
import { calculateScore } from "../utils/scoring";
import { CONSTANTS } from "../utils/constants";
import { PDFDownloadLink } from "@react-pdf/renderer";
import TestPdfDocument from "./TestPDFDoc";
import { clearTestStorage, scrollToBottom } from "../utils/common";
import questions from "../data/questions.json";

const ResultPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = sessionStorage.getItem('test-id');

  const [testId,] = useState(location?.state?.testId || id);
  const [test, setTest] = useState(null);
  const [isTestComplete,] = useState(sessionStorage.getItem(`${testId}-score`) ? true : false);

  useEffect(() => {
    if (!testId) navigate('/')
    let test = location?.state?.test || questions[testId]
    setTest(test)

    // if (isTestComplete) {
    //   setTimeout(() => {
    //     scrollToBottom()
    //   }, 100);
    // }
  }, [])

  const responses = JSON.parse(sessionStorage.getItem(`${testId}-responses`) || "{}");
  const score = Number(sessionStorage.getItem(`${testId}-score`) || 0);
  let { total, interpretation } = calculateScore(testId, responses);
  const sdRange = compute(total, testId);
  const interpretationText = `This score is ${interpretation}.`

  if (!test || !responses) {
    return <div style={{ textAlign: "center", marginTop: 100 }}>No test data found.</div>;
  }

  const handleBackToTest = () => {
    navigate(`/${testId}`)
  }

  const handleBackToHome = () => {
    clearTestStorage()
    navigate(`/`)
  }

  const getScore = (response, question) => {
    if (response < 0) return CONSTANTS.NORESPONSE

    if (testId === CONSTANTS.CATID) { //FOR CAT, ADD IF QUESTION.ADD IS 1
      if (question.add === response)
        return 1
      else return 0
    }

    let obj = test.options.find((it) => it.point === response)
    if (!obj) return CONSTANTS.NORESPONSE

    return obj.point
  }

  return (
    <div className="px-3">
      <div className="bg-orange-100 py-3 px-4 rounded-tl-lg rounded-tr-lg border border-orange-300 mt-4">
        <div className="ml-2 text-lg font-bold text-start justify-start">
          <span className="text-red-600">{test.title} {CONSTANTS.RESULTS}</span>
        </div>
      </div>
      <div className="bg-orange-100 p-4 rounded-bl-lg rounded-br-lg border-x border-b border-orange-300 mb-4">
        <div className="ml-2 text-lg font-bold">
          Score is <span className="text-red-600">{score ?? "N/A"}</span>
        </div>
        <div className="ml-2 text-[16px]">
          {sdRange?.description ?? ""}
        </div>
        <div className="ml-2 text-red-600 font-bold text-lg mt-1">{interpretationText}</div>
      </div>
      <div className="mt-4 flex justify-end mb-6 gap-2">
        <Button type="default" onClick={handleBackToHome}>
          {CONSTANTS.BACKTOQUIZZES}
        </Button>
        <Button type="default" onClick={handleBackToTest}>
          {CONSTANTS.BACKTOTEST}
        </Button>
        <PDFDownloadLink
          document={
            <TestPdfDocument
              test={test}
              responses={responses}
              results={{
                description: `${sdRange?.description}`,
                score,
                interpretation: interpretationText,
              }}
            />}
          fileName={`${test.title}-${CONSTANTS.RESULTS}.pdf`}
        >
          {({ loading }) =>
            <Button
              type="primary"
              loading={loading}
            >{loading ? CONSTANTS.PREPARINGPDF : CONSTANTS.DOWNLOADPDF}
            </Button>
          }
        </PDFDownloadLink>
      </div>
      <Space direction="vertical" className="!w-full">
        {test.questions.map((q, i) => {
          return (
            <Card key={i} className="mb-2">
              <div className="flex">
                <span className="text-gray-500 min-w-9 text-center">{`Q${i + 1}) `}</span>
                {testId === CONSTANTS.BCLID ? (
                  <span className="text-base">
                    <span className="font-semibold">{test.questionPrefix}</span>{" "}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: q.text,
                      }}
                    />
                  </span>
                ) : (
                  <span
                    className="text-base font-semibold"
                    dangerouslySetInnerHTML={{
                      __html: `${test.questionPrefix} ${q.text}`,
                    }}
                  />
                )}
              </div>
              <div className="flex justify-between items-center mt-1">
                <div className="flex">
                  <span className="text-gray-500 min-w-9 text-center">A. </span>
                  {responses[i] > -1
                    ? test.options.find((it) => it.point === responses[i])?.value || ''
                    : CONSTANTS.NORESPONSE}
                </div>
                <div>Score is: <strong>{getScore(responses[i], q)}</strong></div>
              </div>
            </Card>
          )
        })}
      </Space>
      <div className="mt-4 flex justify-end mb-6 gap-2">
        <Button type="default" onClick={handleBackToHome}>
          {CONSTANTS.BACKTOQUIZZES}
        </Button>
        <Button type="default" onClick={handleBackToTest}>
          {CONSTANTS.BACKTOTEST}
        </Button>
        <PDFDownloadLink
          document={
            <TestPdfDocument
              test={test}
              responses={responses}
              results={{
                description: `${sdRange?.description}`,
                score,
                interpretation: interpretationText,
              }}
            />}
          fileName={`${test.title}-${CONSTANTS.RESULTS}.pdf`}
        >
          {({ loading }) =>
            <Button
              type="primary"
              loading={loading}
            >{loading ? CONSTANTS.PREPARINGPDF : CONSTANTS.DOWNLOADPDF}
            </Button>
          }
        </PDFDownloadLink>
      </div>
    </div>
  );
}

export default ResultPage;
